import React from "react"
import { useNavigate } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { closeDialog, selectType } from "redux/features/dialog/dialogSlice"
import {
  PAYMENT_SCHEDULE_CREATE_MODAL,
  PAYMENT_SCHEDULE_VIEW_MODAL,
  PAYMENT_SCHEDULE_SIGN_MODAL,
  PAYMENT_SCHEDULE_PROMISE_MODAL,
  REFINANCE_CONSENT_MODAL,
  PAYMENT_PAY_MODAL,
  BATCH_PAYMENT_PAY_MODAL,
  PAYMENT_SUCCESS_MODAL,
  PAYMENT_FAILURE_MODAL,
  SUBSCRIPTION_CREATE_MODAL,
  SUBSCRIPTION_UPGRADE_MODAL,
  SUBSCRIPTION_CANCEL_MODAL,
  SUBSCRIPTION_BANK_MODAL,
  SUBSCRIPTION_SUCCESS_MODAL,
  SUBSCRIPTION_FAILURE_MODAL,
  ISSUE_CREATE_MODAL,
  PRODUCT_PAYMENT_MODAL,
  PRODUCT_PAYMENT_SUCCESS_MODAL,
  PRODUCT_PAYMENT_FAILURE_MODAL,
  HELP_HOW_MODAL,
  HELP_WHY_MODAL,
  HELP_WHEREFORE_MODAL,
  HELP_WHAT_MODAL,
  SEPA_PAYMENT_PAY_MODAL,
} from "config"
import Modal from "components/ui/Modal"
import PaymentScheduleCreateModal from "components/PaymentSchedule/Create"
import PaymentScheduleViewModal from "components/PaymentSchedule/View"
import PaymentScheduleSignModal from "components/PaymentSchedule/Sign"
import PaymentSchedulePromiseModal from "components/PaymentSchedule/Promise"
import RefinanceConsentModal from "components/Refinance/Sign"
import PaymentPayModal from "components/Payment/Pay"
import BatchPaymentPayModal from "components/BatchPayment/Pay"
import SepaPaymentPayModal from "components/SepaPayment/Pay"
import PaymentSuccessModal from "components/Payment/Success"
import PaymentFailureModal from "components/Payment/Failure"
import SubscriptionCreateModal from "components/Subscription/Modal/Create"
import SubscriptionBankPaymentModal from "components/Subscription/Modal/BankPayment"
import SubscriptionUpgradeModal from "components/Subscription/Modal/Upgrade"
import SubscriptionCancelModal from "components/Subscription/Modal/Cancel"
import SubscriptionSuccessModal from "components/Subscription/Modal/Success"
import SubscriptionFailureModal from "components/Subscription/Modal/Failure"
import IssueCreateModal from "components/Issue/Modal/Create"
import ProductPaymentModal from "components/Products/Payment/Pay"
import ProductPaymentSuccessModal from "components/Products/Payment/Success"
import ProductPaymentFailureModal from "components/Products/Payment/Failure"
import HelpModal from "components/Help/Modal"

const DialogComponent = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const type = useAppSelector((state) => selectType(state))

  const handleClose = (event: object, reason: string) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return false
    }

    dispatch(closeDialog())
    navigate("/")
  }

  return (
    <>
      <Modal
        type="default"
        open={type === PAYMENT_SCHEDULE_CREATE_MODAL}
        onClose={handleClose}
      >
        <PaymentScheduleCreateModal />
      </Modal>

      <Modal
        type="default"
        open={type === PAYMENT_SCHEDULE_VIEW_MODAL}
        onClose={handleClose}
      >
        <PaymentScheduleViewModal />
      </Modal>

      <Modal
        type="default"
        open={type === PAYMENT_SCHEDULE_SIGN_MODAL}
        onClose={handleClose}
      >
        <PaymentScheduleSignModal />
      </Modal>

      <Modal
        type="default"
        open={type === PAYMENT_SCHEDULE_PROMISE_MODAL}
        onClose={handleClose}
      >
        <PaymentSchedulePromiseModal />
      </Modal>

      <Modal
        type="default"
        open={type === REFINANCE_CONSENT_MODAL}
        onClose={handleClose}
      >
        <RefinanceConsentModal />
      </Modal>

      <Modal
        type="thin"
        open={type === PAYMENT_PAY_MODAL}
        onClose={handleClose}
      >
        <PaymentPayModal />
      </Modal>

      <Modal
        type="thin"
        open={type === BATCH_PAYMENT_PAY_MODAL}
        onClose={handleClose}
      >
        <BatchPaymentPayModal />
      </Modal>

      <Modal
        type="thin"
        open={type === SEPA_PAYMENT_PAY_MODAL}
        onClose={handleClose}
      >
        <SepaPaymentPayModal />
      </Modal>

      <Modal
        type="thin"
        open={type === PAYMENT_SUCCESS_MODAL}
        onClose={handleClose}
      >
        <PaymentSuccessModal />
      </Modal>

      <Modal
        type="thin"
        open={type === PAYMENT_FAILURE_MODAL}
        onClose={handleClose}
      >
        <PaymentFailureModal />
      </Modal>

      <Modal
        type="default"
        open={type === SUBSCRIPTION_CREATE_MODAL}
        onClose={handleClose}
      >
        <SubscriptionCreateModal />
      </Modal>

      <Modal
        type="default"
        open={type === SUBSCRIPTION_UPGRADE_MODAL}
        onClose={handleClose}
      >
        <SubscriptionUpgradeModal />
      </Modal>

      <Modal
        type="thin"
        open={type === SUBSCRIPTION_CANCEL_MODAL}
        onClose={handleClose}
      >
        <SubscriptionCancelModal />
      </Modal>

      <Modal
        type="thin"
        open={type === SUBSCRIPTION_BANK_MODAL}
        onClose={handleClose}
      >
        <SubscriptionBankPaymentModal />
      </Modal>

      <Modal
        type="thin"
        open={type === SUBSCRIPTION_SUCCESS_MODAL}
        onClose={handleClose}
      >
        <SubscriptionSuccessModal />
      </Modal>

      <Modal
        type="thin"
        open={type === SUBSCRIPTION_FAILURE_MODAL}
        onClose={handleClose}
      >
        <SubscriptionFailureModal />
      </Modal>

      <Modal
        type="thin"
        open={type === ISSUE_CREATE_MODAL}
        onClose={handleClose}
      >
        <IssueCreateModal />
      </Modal>

      <Modal
        type="thin"
        open={type === PRODUCT_PAYMENT_MODAL}
        onClose={handleClose}
      >
        <ProductPaymentModal />
      </Modal>

      <Modal
        type="thin"
        open={type === PRODUCT_PAYMENT_SUCCESS_MODAL}
        onClose={handleClose}
      >
        <ProductPaymentSuccessModal />
      </Modal>

      <Modal
        type="thin"
        open={type === PRODUCT_PAYMENT_FAILURE_MODAL}
        onClose={handleClose}
      >
        <ProductPaymentFailureModal />
      </Modal>

      <Modal type="medium" open={type === HELP_HOW_MODAL} onClose={handleClose}>
        <HelpModal type="how" />
      </Modal>
      <Modal type="medium" open={type === HELP_WHY_MODAL} onClose={handleClose}>
        <HelpModal type="why" />
      </Modal>
      <Modal
        type="medium"
        open={type === HELP_WHEREFORE_MODAL}
        onClose={handleClose}
      >
        <HelpModal type="wherefore" />
      </Modal>
      <Modal
        type="medium"
        open={type === HELP_WHAT_MODAL}
        onClose={handleClose}
      >
        <HelpModal type="what" />
      </Modal>
    </>
  )
}

export default DialogComponent
